import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { getPlantationAction } from './APIs/action';

const Plantation = () => {
  const [searchParams] = useSearchParams();
  const [iframeUrl, setIframeUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const plantation_id = searchParams.get('plantation_id');
    const fetchData = async () => {
      const res = await getPlantationAction(plantation_id);
      setLoading(false);
      if (!res?.error && res?.data?.planted_info_url) {
        setIframeUrl(res.data.planted_info_url);
      } else {
        setError(true);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Failed to load plantation details.</p>
      </div>
    );
  }

  return (
    <iframe
      src={iframeUrl}
      title="Plantation Info"
      style={{ width: '100%', height: '100vh', border: 'none' }}
    />
  );
};

export default Plantation;
